export class InformationModel {

    private documentTypeId: string;
    private documentTypeName: string;
    private document: string;
    private name: string;

    public getDocumentTypeId(): string {
        return this.documentTypeId;
    }

    public setDocumentTypeId(documentTypeId: string): void {
        this.documentTypeId = documentTypeId;
    }

    public getDocumentTypeName(): string {
        return this.documentTypeName;
    }

    public setDocumentTypeName(documentTypeName: string): void {
        this.documentTypeName = documentTypeName;
    }

    public getDocument(): string {
        return this.document;
    }

    public setDocument(document: string): void {
        this.document = document;
    }

    public getName(): string {
        return this.name;
    }

    public setName(name: string): void {
        this.name = name;
    }

    public deserialize(input: any) {
        Object.assign(this, input);

        for (const key in input) {
            if (Object.prototype.hasOwnProperty.call(input, key)) {
                if (this['set' + key.charAt(0).toUpperCase() + key.slice(1)]) {
                    this['set' + key.charAt(0).toUpperCase() + key.slice(1)](input[key]);
                }
            }
        }

        return this;
    }

}
